"use strict";

exports.__esModule = true;
var _UserRoutes = require("./UserRoutes");
Object.keys(_UserRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserRoutes[key]) return;
  exports[key] = _UserRoutes[key];
});